import styled, { css, keyframes } from 'styled-components'
import spin from '../../styles/animations/spin'

export const OverlayStyle = {
  Container: styled.div`
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(4px);

    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
  `,
  Inner: styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    max-width: 300px;
    text-align: center;
  `,
  InnerContentText: styled.div`
    color: #333;
    font-size: 16px;
    font-weight: 500;
    margin-top: 10px;
  `,
  InnerContent: styled.div`
    margin: auto;
  `,
  Spinner: styled.div`
    width: 60px;
    height: 60px;
    display: inline-block;
    border-width: 3px;
    border-color: #f3f3f3;
    border-top-color: #007bff;
    ${spin}
    border-radius: 100%;
    border-style: solid;
  `,
}
